import template from './premium-feedback.comp.html'
import './premium-feedback.scss'

export default angular.module('flatastic.component.premium-feedback', [])
.component('premiumFeedback', {
  template,
})
.name;
